import React from "react";
import { useFormContext } from "react-hook-form";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";
import { getOptionsFromEnums } from "../../../../shared/utility";
import { preferenceEnums } from "../../../../system/global-enums";

const options = getOptionsFromEnums(preferenceEnums.HEALTH_PRIORITY);
const HealthCare = () => {
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <div>
      <div className="question-heading">
        How important is healthcare to you?
      </div>
        {errors.healthPriority && (
          <div className="error">{errors.healthPriority.message}</div>
        )}
      <div className="form-fields">
        {options.map((option, index) => (
          <SurveyFormField
            name="healthPriority"
            key={index}
            variant="radio"
            label={option.label}
            value={option.value}
          />
        ))}
      </div>
    </div>
  );
};

export default HealthCare;
